import React, { useCallback } from 'react'
import 'whatwg-fetch'
import Route from 'route-parser'
import { toast } from 'react-toastify'
import { saveAs } from 'file-saver'
import { values } from 'libraries/lodash'
import ErrorIcon from '@material-ui/icons/Error'
import { toQueryString } from 'front-end-core/core/url'
import notificationToast from 'helpers/notificationToast'
import DealProperties from 'pages/mwdealdetails/DealProperties'
import DealMilestones from 'pages/mwdealdetails/DealMilestones'
import DealParameters from 'pages/mwdealdetails/DealParameters'
import DealDocuments from 'pages/mwdealdetails/DealDocuments'
import { LayoutHistoryBack } from 'components/dealwatch/Layout'

const DealDetails = ({ deal, dealId, timeline, dealType, parameters, pageToggleOverlay }) => {
  const onClickDownload = useCallback((downloadUrl, saveName) => {
    fetch(downloadUrl)
      .then(async response => {
        const buffer = await response.arrayBuffer()
        saveAs(
          new Blob([buffer]),
          saveName
        )
      })
      .catch(error => {
        console.error(error)
        notificationToast(<ErrorIcon />, toast.TYPE.ERROR, `Failed to save ${saveName}`, 'bg-indian-red white')
      })
  }, [])

  const downloadUrl = (url, params, query) => new Route(url).reverse(params) + toQueryString(query)

  const documents = values(deal.documents)

  return (
    <div
      className='layout-width-constraint w-100 vw-100-t'
    >
      <LayoutHistoryBack />
      <DealProperties {...{ deal, dealType, dealId, downloadUrl, onClickDownload }} />
      <DealMilestones {...{ dealId, timeline }} />
      <DealParameters params={parameters} {...{ dealId }} />
      <DealDocuments {...{ documents, downloadUrl, dealId, onClickDownload }} />
    </div>
  )
}

export default DealDetails
